<div class="l-mybooking" *ngIf="!(myBooking$ | async)?.checkInServiceApplication">
  <div class="l-wrap">
    <div class="l-wrap__inner">
      <!-- 予約詳細ヘッダ -->
      <div class="l-mybooking__item l-mybooking__item--tb-pc-2col" role="dialog" aria-label="Title">
        <div class="l-mybooking__title">
          <asw-my-booking-infor></asw-my-booking-infor>
        </div>
        <div class="l-mybooking__option" *ngIf="isDisplayReservation">
          <asw-next-action [pnrInfo]="pnr"></asw-next-action>
          <!-- 39		eチケット/EMD表示	 -->
          <div class="l-mybooking__option-item" *ngIf="displayEMD">
            <a href="javascript:void(0)" id="show-e-ticket" class="c-next-action01" (click)="clickETicketAndEmd()">
              <div class="c-next-action01__body">
                <div
                  class="c-next-action01__title c-next-action01__title--em"
                  [innerHTML]="'label.showETicketAndEmd' | staticMsg"
                ></div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="l-mybooking__item">
        <asw-my-booking-tabs
          [activeNum]="myBookingService.tabActive"
          #reservationTabComponent
          (selectEvent)="onGetTabClick($event)"
        >
          <!-- 予約詳細（旅程） -->
          <asw-my-booking-tabs-item
            [title]="'label.flightDetails2'"
            src="assets/images/icon_plane_line_gray70_32.svg"
            srcActive="{{ appConstants.IMG.S01_P030_S01_U__PLANE_ACTIVE }}"
            [index]="MY_BOOKING_TAB_SHOW_Itinerary"
          ></asw-my-booking-tabs-item>
          <!-- 予約詳細（搭乗者） -->
          <asw-my-booking-tabs-item
            [title]="'label.manageBooking'"
            src="assets/images/icon_avator_gray70_32.svg"
            srcActive="{{ appConstants.IMG.S01_P030_S01_U__AVATOR_ACTIVE }}"
            [index]="MY_BOOKING_TAB_SHOW_Traveler"
          >
          </asw-my-booking-tabs-item>
          <!-- 予約詳細（サービス） -->
          <asw-my-booking-tabs-item
            [title]="'label.services'"
            src="assets/images/icon_checkin_seat_gray70_32.svg"
            srcActive="{{ appConstants.IMG.S01_P030_S01_U__CHECKIN_SEAT_ACTIVE }}"
            [index]="MY_BOOKING_TAB_SHOW_Service"
          ></asw-my-booking-tabs-item>
        </asw-my-booking-tabs>
      </div>
      <!-- </ng-container> -->
    </div>
  </div>
</div>

<div class="l-core-contents">
  <div class="l-wrap">
    <div>
      <div *ngIf="myBookingService.tabActive === MY_BOOKING_TAB_SHOW_Itinerary">
        <asw-my-booking-itinerary-cont></asw-my-booking-itinerary-cont>
      </div>
      <div *ngIf="myBookingService.tabActive === MY_BOOKING_TAB_SHOW_Traveler">
        <asw-my-booking-passenger-cont></asw-my-booking-passenger-cont>
      </div>
      <div
        *ngIf="
          myBookingService.tabActive === MY_BOOKING_TAB_SHOW_Service || (myBooking$ | async)?.checkInServiceApplication
        "
      >
        <asw-my-booking-services></asw-my-booking-services>
      </div>
    </div>
  </div>
</div>
